// extracted by mini-css-extract-plugin
export var centerText = "_cr-8";
export var container = "_cr-0";
export var doughnutContainer = "_cr-7";
export var legend = "_cr-a";
export var legendItemColorDisplay = "_cr-b";
export var legendItemLabel = "_cr-d";
export var legendItemValue = "_cr-c";
export var lg = "_cr-5";
export var maxWidth = "_cr-9";
export var md = "_cr-4";
export var responsive = "_cr-6";
export var sm = "_cr-3";
export var xs = "_cr-2";
export var xxs = "_cr-1";